import Search, { SearchClientConfig, SearchInitConfig, ViewFilterType } from './search/search';
import MainSearch from './search/extends/main-search';
import LandingSearchManager from './search/extends/landing-search-manager';
import ProgramsAndCoursesSearch from './search/extends/programs-and-courses-search';
import SADTSearch from './search/extends/sadt-search';
import SYOSearch from './search/extends/syo-search';

// search helper functions
import SearchUtility from "./search/utilities/search-utility";
import Utility from "./classes/utility";
import { MenuItem } from "instantsearch.js/es/connectors/menu/connectMenu";
import MainSearchCustomRender from './search/customRenders/main-search-render';
import SYOSearchCustomRender from './search/customRenders/syo-search-custom-render';
import PCSearchCustomRender from './search/customRenders/pc-custom-render';
import SCustomElements from './classes/custom-elements';

// main Search
const mainItemTemplate =
    require("../templates/components/search/partials/main-item-search--list").default;
const mainNoResultsTemplate =
    require("../templates/components/search/partials/main-no-results").default;

// programs & Courses Search
const programItemSearchList =
    require("../templates/components/search/program-search/program-listing--list").default;
const programItemSkeletonList =
    require("../templates/components/search/partials/program-item-skeleton--list").default;
const programItemSearchGrid =
    require("../templates/components/search/partials/program-item-search--grid").default;
const programItemSkeletonGrid =
    require("../templates/components/search/partials/program-item-skeleton--list").default;

// SADT Programs
const sadtCardList =
    require("../templates/components/search/partials/sadt-program-item-search--grid").default;

// SYO Programs
const syoProgramList =
    require("../templates/components/search/partials/syo-program-item-search--list").default;

// define search connection values
const algoliaAppId = "LKAY4PJWX5";
const algoliaApiKey = "8c1c571e443b6eba5cdc01fc902fa9e1";

// global window defines
declare global {
    interface Window {
        search: Search;
        landingSearch: Search;
        pcSearch: Search;
        aa: any;
        saitIdent: string;
    }
}

const getClientIdent = async () => {
    await Utility.asyncLocalStorage.getItem("sait-ident").then((value) => {
        if (value === null) {
            // generate sait identifier for user
            let saitIdent = `anonymous-${Utility.uuidv4()}`;
            Utility.asyncLocalStorage.setItem("sait-ident", saitIdent);
            window.saitIdent = saitIdent;
        } else {
            window.saitIdent = value;
        }
    });
};

const globalInit = function () {
    // define sait custom elements
    SCustomElements.landingSearch();

    //init landing search
    const landingComp = document.querySelector("landing-search") as HTMLElement;
    if (landingComp !== null) {
        let facets = JSON.parse(landingComp.dataset.facets);
        if (!facets) {
            facets = {
                facets: []
            }
        }
        initLandingSearch(landingComp, landingComp.dataset.index, facets.facets);
    }

    const mainSearchBox = document.getElementById("ms-box");
    if (mainSearchBox !== null) {
        initMainSearch();
    }

    // init this search for Programs & Courses
    const searchBox = document.getElementById("search-box"); // a unique id for Program and Courses search box
    if (searchBox !== null) {
        initProgramsCoursesSearch(searchBox);
    }

    //SYO Init search 
    const syoSearchBox = document.getElementById("syo-search-box");
    if(syoSearchBox !== null){
        initSYOProgramsSearch(syoSearchBox);
    }
};

// landing search logic
function initLandingSearch(landingComponent: HTMLElement, index: string, facets: Array<any>) {
    // define the search client config
    let clientConfig: SearchClientConfig = {
        appId: algoliaAppId,
        apiKey: algoliaApiKey,
        indexName: index,
        lazyLoading: true,
        hitsPerPage: 15
    };
    let landingSearchManager = new LandingSearchManager(clientConfig);
    landingSearchManager.setRootComponent(landingComponent);
    landingSearchManager.start(facets);
    window.landingSearch = landingSearchManager.search;
}

const initProgramsCoursesSearch = async (searchBox: HTMLElement) => {
    let dataDisplay = searchBox.getAttribute("data-display") != null
        ? searchBox.getAttribute("data-display")
        : "list";
    let cssClasses = {
        root: "",
    };
    // if grid, add row class for grid
    if (dataDisplay == "grid") {
        cssClasses.root = "row list-unstyled";
    }

    // console.log("pc -log ");
    // console.log("pc -log yes");

    // define the search client config
    let clientConfig: SearchClientConfig = {
        appId: algoliaAppId,
        apiKey: algoliaApiKey,
        indexName: "programs-courses",
        lazyLoading: true,
        hitsPerPage: 15
    };
    // define the search init config
    let initConfig: SearchInitConfig = {
        allowEmptyQuery: true,
        showOnLoad: true,
        searchBoxId: "search-box",
        resultContainerId: "hits",
        activeTemplate: dataDisplay,
        templates: {
            list: programItemSearchList,
            //grid: programItemSearchGrid,
        },
        skeletonTemplates: {
            list: programItemSkeletonList,
            //grid: programItemSkeletonGrid,
        },
        cssClasses: cssClasses,
        customRender: PCSearchCustomRender.customRender
    };
    let search = await new ProgramsAndCoursesSearch(clientConfig, initConfig);

    // SearchUtility tabs and aoi/school page logic
    //await SearchUtility.setAOIOrSchoolPage(search, searchBox);
    //await SearchUtility.tabsClickEvents(search, searchBox, "ProgramPage", false);

    // define the search in the global window
    await search.onLoad([]);
    window.pcSearch = search;
};

const initMainSearch = async () => {
    // Define the search client config
    let clientConfig: SearchClientConfig = {
        appId: algoliaAppId,
        apiKey: algoliaApiKey,
        indexName: "main",
        lazyLoading: true,
        hitsPerPage: 15
    };
    // Define the search init config
    let initConfig: SearchInitConfig = {
        allowEmptyQuery: true,
        searchBoxId: "ms-box",
        placeholderId: "mainSearchWrap-placeholderText",
        showOnLoad: false,
        resultContainerId: "ms-hits",
        queryName: "q",
        textboxPlaceholder: "Enter your search term here",
        activeTemplate: "list",
        templates: {
            list: mainItemTemplate,
            empty: mainNoResultsTemplate,
        },
        customRender: MainSearchCustomRender.customRender,
        firstRenderFn: MainSearch.firstRenderFn,
    }
    // Initialize the MainSearch class
    let search = await new MainSearch(clientConfig, initConfig);
    // Start the search
    await search.onLoad([]);
    window.search = search;
}

const initSYOProgramsSearch = async (searchBox: HTMLElement) => {
    const dataDisplay = searchBox.getAttribute("data-display") != null
        ? searchBox.getAttribute("data-display")
        : "list";
    let clientConfig: SearchClientConfig = {
        appId: algoliaAppId,
        apiKey: algoliaApiKey,
        indexName: "syo",
        lazyLoading: true,
        hitsPerPage: 15
    };
    let initConfig: SearchInitConfig = {
        allowEmptyQuery: true,
        showOnLoad: true,
        searchBoxId: "syo-search-box",
        resultContainerId: "hits",
        activeTemplate: dataDisplay,
        templates: {
            list: syoProgramList,
        },
        customRender: SYOSearchCustomRender.customRender
    };
    let search = await new SYOSearch(clientConfig, initConfig);

    // define facets for persistent filters
    search.onLoad([{
        key: "type",
        value: "CampDetail",
    }]);

    // tabs on search page
    await SearchUtility.tabsClickEvents(search, searchBox, "CampDetail", true);
};

//TODO: This might not be needed. Can be removed.
/*const initSADTPrograms = async (searchBox: HTMLElement) => {
    let clientConfig: SearchClientConfig = {
        appId: algoliaAppId,
        apiKey: algoliaApiKey,
        indexName: "HH-Sait-Programs-Courses",
        lazyLoading: false,
        hitsPerPage: 15
    };
    let initConfig: SearchInitConfig = {
        allowEmptyQuery: true,
        showOnLoad: true,
        searchBoxId: "sadt-search-box",
        resultContainerId: "hits",
        activeTemplate: "grid",
        templates: {
            grid: sadtCardList,
        },
        cssClasses: {
            root: "row program-card-row",
        },
        infiniteScroll: false,
    };
    let search = await new SADTSearch(clientConfig, initConfig);

    search.onLoad([
        {
            key: "recordObj.type",
            value: "ProgramPage",
        },
        {
            key: "recordObj.categories.categorySchools.value",
            value: "digitalTechnology",
        }
    ]);

    //infinite scrolling was causing cards to break up weirdly, so removed row and added class to #hits to encompass all cards
    let resultContainer = document.getElementById("hits") as HTMLElement;
    resultContainer.classList.add("row", "program-card-row");
};*/

window.addEventListener('DOMContentLoaded', function() {
    getClientIdent();
    globalInit();
});